import guest from "../helper/middleware/guest";

export default [
  {
    path: "/masuk",
    name: "login",
    component: () => import("@/views/auth/LoginView.vue"),
    meta: { middleware: [guest] },
  },
  {
    path: "/lupa-sandi",
    name: "forgot",
    component: () => import("@/views/auth/ForgotView.vue"),
    meta: { middleware: [guest] },
  },
  {
    path: "/verifikasi-otp",
    name: "verifyOTP",
    component: () => import("@/views/auth/VerifyOTPView.vue"),
    meta: { middleware: [guest] },
  },
  {
    path: "/ubah-sandi",
    name: "changePassword",
    component: () => import("@/views/auth/ChangePasswordView.vue"),
    // meta: { middleware: [auth, first] },
  },
];
